var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "游戏", clearable: "", filterable: "" },
                  model: {
                    value: _vm.paramsData.appid,
                    callback: function($$v) {
                      _vm.$set(_vm.paramsData, "appid", $$v)
                    },
                    expression: "paramsData.appid"
                  }
                },
                _vm._l(_vm.gameList, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.show_name, value: item.appid }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "服务器名称" },
                model: {
                  value: _vm.paramsData.server_name,
                  callback: function($$v) {
                    _vm.$set(_vm.paramsData, "server_name", $$v)
                  },
                  expression: "paramsData.server_name"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.getList(1)
                    }
                  }
                },
                [_vm._v("搜索")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.$refs.addserversList.init()
                }
              }
            },
            [_vm._v("新增")]
          ),
          _vm.delIds.length
            ? _c(
                "el-button",
                {
                  attrs: { type: "danger" },
                  on: {
                    click: function($event) {
                      return _vm.del(_vm.delIds)
                    }
                  }
                },
                [_vm._v("删除")]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticClass: "topBannerTable",
          attrs: { data: _vm.pagingList, border: "" },
          on: { "selection-change": _vm.handleSelectionChange }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "id", label: "ID", width: "60", type: "selection" }
          }),
          _c("el-table-column", {
            attrs: { prop: "id", label: "ID", width: "60" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            return _vm.capy(row)
                          }
                        }
                      },
                      [_vm._v(_vm._s(row.id))]
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "game_show_name", label: "游戏" }
          }),
          _c("el-table-column", {
            attrs: { prop: "show_name", label: "显示名称" }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "product_check_link",
              label: "商品检测链接",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      {
                        on: {
                          click: function($event) {
                            return _vm.$utils.copyText(row.product_check_link)
                          }
                        }
                      },
                      [
                        _vm._v(
                          " " + _vm._s(row.product_check_link || "/") + " "
                        )
                      ]
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "login_callback",
              label: "登录回调地址",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "text-ellipsis-1",
                        staticStyle: { width: "200px", "text-align": "center" },
                        on: {
                          click: function($event) {
                            return _vm.$utils.copyText(row.login_callback)
                          }
                        }
                      },
                      [_vm._v(" " + _vm._s(row.login_callback || "/") + " ")]
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "pay_callback",
              label: "支付回调地址",
              "show-overflow-tooltip": "",
              width: "220"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "text-ellipsis-1",
                        staticStyle: { width: "210px" },
                        on: {
                          click: function($event) {
                            return _vm.$utils.copyText(row.pay_callback)
                          }
                        }
                      },
                      [_vm._v(" " + _vm._s(row.pay_callback || "/") + " ")]
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "extend", label: "扩展参数" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      {
                        staticStyle: { color: "#409EFF" },
                        on: {
                          click: function($event) {
                            return _vm.$refs.serversListextendView.init(
                              row.extend
                            )
                          }
                        }
                      },
                      [_vm._v("查看")]
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "recharge_desc", label: "语言信息" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      {
                        staticStyle: { color: "#409EFF" },
                        on: {
                          click: function($event) {
                            return _vm.openView(row)
                          }
                        }
                      },
                      [_vm._v("查看")]
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "state", label: "状态" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          row.state == 2
                            ? "启用"
                            : row.state == 1
                            ? "禁用"
                            : "敬请期待"
                        ) +
                        " "
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "state", label: "定时任务" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function(ref) {
                    var row = ref.row
                    return row.has_delayed_task
                      ? [
                          _c(
                            "div",
                            {
                              staticStyle: { color: "#409EFF" },
                              on: {
                                click: function($event) {
                                  return _vm.$refs.scheduledTask.init(row)
                                }
                              }
                            },
                            [_vm._v("展示")]
                          )
                        ]
                      : undefined
                  }
                }
              ],
              null,
              true
            )
          }),
          _c("el-table-column", {
            attrs: { prop: "state", label: "操作", width: "180px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.$refs.addserversList.init(row, "1")
                          }
                        }
                      },
                      [_vm._v("新增定时")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "success" },
                        on: {
                          click: function($event) {
                            return _vm.$refs.addserversList.init(row)
                          }
                        }
                      },
                      [_vm._v("修改")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger" },
                        on: {
                          click: function($event) {
                            return _vm.del([row])
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm.pagingList.length
        ? _c("el-pagination", {
            staticClass: "x-c",
            attrs: {
              layout: "total, prev, pager, next,jumper",
              "current-page": _vm.paramsData.page,
              total: _vm.totalNum,
              "page-size": _vm.paramsData.page_size
            },
            on: { "current-change": _vm.getList }
          })
        : _vm._e(),
      _c("addserversList", {
        ref: "addserversList",
        attrs: { gameLists: _vm.gameList },
        on: { change: _vm.getList }
      }),
      _c("serversListView", { ref: "serversListView" }),
      _c("serversListextendView", { ref: "serversListextendView" }),
      _c("scheduledTask", { ref: "scheduledTask" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }